import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {StorageService} from "../../services/storage.service";

let called = false;
let authorities: string[];
let permissions$: Observable<string | string[]>;

@Directive({
  selector: '[appHasPermission]'
})
export class HasPermissionDirective {

  private permissions: any = '';
  private rendered = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private storageService: StorageService
  ) { }

  @Input()
  set appHasPermission(val: string | string[] | undefined) {
    this.permissions = val;
    this.updateView();
  }

  private updateView() {
    if (!this.rendered) {
      if (this.checkPermission()) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.rendered = true;
      } else {
        this.viewContainer.clear();
      }
    }
  }

  private checkPermission() {
    if (this.permissions.length > 0) {
      let appHasPermission = this.storageService.get('authorities')?.split(',')?.some(a => (Array.isArray(this.permissions) ? this.permissions : [this.permissions]).includes(a));
      return environment.ALLOW_PERMISSIONS ? appHasPermission : true;
    }
    return true;
  }

}
